// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pg-service-order-tracking-common":"3f67a59dc4e8b82b8f57","OrderTracking":"8119cff87c68328fa188","OrderTrackingInformation":"c3eb8b752afbd4e32425","OrderStatusInfo":"af8625f72441f5901542"}[chunkId] + ".bundle.js";
};